import { useEffect, useRef } from 'react';
import { trackingService } from '../services/trackingService';

const CONTACT_SYNC_DEBOUNCE_MS = 1000;
const MIN_PHONE_DIGITS = 10;
const MAX_PHONE_DIGITS = 13;
const MAX_NAME_LENGTH = 150;
const MASKED_NAME_MARKER = '*';

export function useCartContactSync(name: string, phone: string, enabled: boolean): void {
  const lastSentKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!enabled) return;

    const trimmedName = name.trim();
    const digits = phone.replace(/\D/g, '');
    const isValid =
      trimmedName.length > 0 &&
      trimmedName.length <= MAX_NAME_LENGTH &&
      !trimmedName.includes(MASKED_NAME_MARKER) &&
      digits.length >= MIN_PHONE_DIGITS &&
      digits.length <= MAX_PHONE_DIGITS;
    if (!isValid) return;

    const key = `${trimmedName}|${digits}`;
    if (key === lastSentKeyRef.current) return;

    const timer = setTimeout(() => {
      lastSentKeyRef.current = key;
      trackingService.saveCartContact(trimmedName, digits);
    }, CONTACT_SYNC_DEBOUNCE_MS);

    return () => clearTimeout(timer);
  }, [name, phone, enabled]);
}
